<div data-row-span="12">
  <div data-field-span="2" title="{{ name }} Flight Time">
    <label>
      <strong>{{ name }}</strong>
    </label>
    <input type="text" disabled readonly />
  </div>
  <div data-field-span="2" title="{{ name }} Flight Time" class="readonly">
    <label>Time</label> <input type="number" readonly [formControl]="time" />
  </div>
  <div data-field-span="1" title="{{ name }} Starts">
    <label>Starts</label> <input type="number" [formControl]="starts" min="0" />
  </div>
  <div
    data-field-span="1"
    *ngFor="let cycle of cycleControls; trackBy: trackCyclesControlsBy"
    title="{{ name }}: {{ cycle.name }} Cycles"
    [flValidationState]="cycle.control"
  >
    <label>{{ cycle.name }}</label>
    <input type="number" [formControl]="cycle.control" min="0" />
  </div>
</div>
